module.exports = __webpack_public_path__ + "img/icon_yctgg.40166c3d.png";